/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CreateReportDefinitionMutationResponse, CreateReportDefinitionPathParams, CreateReportDefinition400 } from "../models/CreateReportDefinition";

export function getCreateReportDefinitionUrl(reportType: CreateReportDefinitionPathParams["reportType"]) {
  const res = { method: 'POST', url: `/report-definitions/${reportType}` as const }
  return res
}

/**
 * @description Creates a new report definition from the latest blueprint version for the specified report type
 * @summary Create new report definition
 * {@link /report-definitions/:reportType}
 */
export async function createReportDefinition(reportType: CreateReportDefinitionPathParams["reportType"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<CreateReportDefinitionMutationResponse, ResponseErrorConfig<CreateReportDefinition400>, unknown>({ method : "POST", url : getCreateReportDefinitionUrl(reportType).url.toString(), ... requestConfig })
  return res.data
}